import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
Vue.use(DatePicker)
import VModal from 'vue-js-modal'
import 'vue2-datepicker/index.css'
import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'


Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false } })


Vue.use(Tooltip)

window.Vue = Vue




// WEBPACK FOOTER //
// ./src/js/vendor.js